import * as React from 'react'
import { cn } from '@/lib/utils'

/**
 * Frame for any tab page. Adds a soft ambient gradient mesh behind glass cards.
 * Use as the outermost wrapper inside the dashboard <main>.
 */
export function PageShell({ className, children }: { className?: string; children: React.ReactNode }) {
  return (
    <div className={cn('relative space-y-5 md:space-y-6', className)}>
      {/* Ambient background mesh — fixed, behind everything in this shell */}
      <div aria-hidden className="pointer-events-none fixed inset-0 -z-10 overflow-hidden">
        <div className="absolute -top-32 -left-32 h-[520px] w-[520px] rounded-full bg-orange-500/10 blur-3xl" />
        <div className="absolute top-1/3 -right-32 h-[420px] w-[420px] rounded-full bg-violet-500/10 blur-3xl" />
        <div className="absolute bottom-0 left-1/3 h-[360px] w-[360px] rounded-full bg-cyan-500/10 blur-3xl" />
      </div>
      {children}
    </div>
  )
}
